import { jsx as r } from "react/jsx-runtime";
import { c as e } from "./clsx.OuTLNxxd.js";
import { NeuFeedback as o } from "@hcahealthcaredpx/neutron-react";
const p = ({ isLoading: n, className: i }) => n ? /* @__PURE__ */ r("div", { className: e("input-spinner", i), children: /* @__PURE__ */ r(o, { kind: "spinner", color: "main", direction: "horizontal", className: "gap-0" }) }) : null;
export {
  p as I
};
